import { useState } from 'react'

export const useModalState = (initialModal = 'share') => {
  const [state, setState] = useState({
    currentModal: initialModal,
    isConfirmationPopupOpen: false,
    actionType: null,
  })

  const openModal = (modalName) => {
    // Open a specific modal
    setState((prevState) => ({
      ...prevState,
      currentModal: modalName,
    }))
  }

  const closeModal = (onClose) => {
    // Go back to the root modal (share) and close it
    setState((prevState) => ({
      ...prevState,
      currentModal: 'share',
    }))
    onClose()
  }

  const handleOpenConfirmationPopup = (type) => {
    // Open the confirmation popup if the user selects "X" or "Back" and save which action they took
    setState((prevState) => ({
      ...prevState,
      actionType: type,
      isConfirmationPopupOpen: true,
    }))
  }

  const handleCloseConfirmationPopup = () => {
    setState((prevState) => ({
      ...prevState,
      isConfirmationPopupOpen: false,
      actionType: null,
    }))
  }

  const handleConfirmAction = (onClose, onBack) => {
    // Handle the user's action (close or back) and close the confirmation popup
    if (state.actionType === 'close') {
      closeModal(onClose)
    } else if (state.actionType === 'back') {
      openModal('share')
      if (onBack) {
        onBack()
      }
    }
    handleCloseConfirmationPopup()
  }

  return {
    currentModal: state.currentModal,
    openModal,
    closeModal,
    isConfirmationPopupOpen: state.isConfirmationPopupOpen,
    handleOpenConfirmationPopup,
    handleCloseConfirmationPopup,
    handleConfirmAction,
  }
}
